<!--*****************************************************************
  * Copyright (c) Certus Software, 2021.                            *
  *                                                                 *
  * This unpublished material is proprietary to Certus Software.    *
  * All rights reserved. The methods and techniques described       *
  * herein are considered confidential and/or trade secrets.        *
  * Reproduction or distribution, in whole or in part, is forbidden *
  * except by express written permission of Certus Software.        *
  *****************************************************************-->

<mat-sidenav-container [hasBackdrop]="true" class="{{translate.currentLang}} {{(isLoggedIn | async)?'main-container':''}}">
  <mat-sidenav #drawer [mode]="'over'" [position]="'end'" [fixedInViewport]="true">
    <div class="drawer-menu">
      <button class="close-sidenav-btn" (click)="drawer.close()">
        <span class="mm"></span>
        <span class="visible-hidden">{{'app.closeMenu' | translate}}</span>
      </button>
      <div class="drawer-buttons">
        <a *ngIf="!(isLoggedIn | async)" class="drawer-btn" [routerLink]="'/'" (click)="drawer.close()" routerLinkActive="active-m" [routerLinkActiveOptions]="{exact:true}" ariaCurrentWhenActive="page">
          {{'app.titles.homepage' | translate}}
        </a>
        <a [routerLink]="'/guide'" class="drawer-btn" (click)="drawer.close()" routerLinkActive="active-m"
           [attr.aria-current]="(router?.url === '/guide')?'page':((this.router.url.includes('/guide'))?'location':null)"
           [ariaCurrentWhenActive]="(router?.url === '/guide')?'page':((this.router.url.includes('/guide'))?'location':null)">
          {{'app.titles.guide' | translate}}
        </a>
        <div class="guide-submenu">
          <a class="drawer-btn guide-section" [routerLink]="'/guide/pc'" (click)="drawer.close()" routerLinkActive="active-m" [routerLinkActiveOptions]="{exact:true}" ariaCurrentWhenActive="page">
            {{'app.titles.guideItems.pcLabel' | translate}}
          </a>
          <a class="drawer-btn" [routerLink]="'/guide/pc/windows'" (click)="drawer.close()" routerLinkActive="active-m" [routerLinkActiveOptions]="{exact:true}" ariaCurrentWhenActive="page">
            <img src="assets/img/icons/windows.svg" aria-hidden="true" alt="" width="16px">
            <span class="small">{{'app.titles.guideItems.windows' | translate}}</span>
          </a>
          <a class="drawer-btn" [routerLink]="'/guide/pc/macos'" (click)="drawer.close()" routerLinkActive="active-m" [routerLinkActiveOptions]="{exact:true}" ariaCurrentWhenActive="page">
            <img src="assets/img/icons/apple.svg" aria-hidden="true" alt="" height="16px">
            <span class="small">{{'app.titles.guideItems.apple' | translate}}</span>
          </a>
          <a class="drawer-btn" [routerLink]="'/guide/pc/linux'" (click)="drawer.close()" routerLinkActive="active-m" [routerLinkActiveOptions]="{exact:true}" ariaCurrentWhenActive="page">
            <img src="assets/img/icons/linux.svg" aria-hidden="true" alt="" height="16px">
            <span class="small">{{'app.titles.guideItems.linux' | translate}}</span>
          </a>
          <a class="drawer-btn guide-section" [routerLink]="'/guide/mobile'" (click)="drawer.close()" routerLinkActive="active-m" [routerLinkActiveOptions]="{exact:true}" ariaCurrentWhenActive="page">
            {{'app.titles.guideItems.mobileLabel' | translate}}
          </a>
          <a class="drawer-btn" [routerLink]="'/guide/mobile/android'" (click)="drawer.close()" routerLinkActive="active-m" [routerLinkActiveOptions]="{exact:true}" ariaCurrentWhenActive="page">
            <img src="assets/img/icons/android.svg" aria-hidden="true" alt="" width="16px">
            <span class="small">{{'app.titles.guideItems.android' | translate}}</span>
          </a>
          <a class="drawer-btn" [routerLink]="'/guide/mobile/ios'" (click)="drawer.close()" routerLinkActive="active-m" [routerLinkActiveOptions]="{exact:true}" ariaCurrentWhenActive="page">
            <img src="assets/img/icons/ios.svg" aria-hidden="true" alt="" width="13px">
            <span class="small">{{'app.titles.guideItems.macos' | translate}}</span>
          </a>
        </div>
        <a class="drawer-btn" [routerLink]="'/devices/supported'" (click)="drawer.close()" routerLinkActive="active-m" [routerLinkActiveOptions]="{exact:true}" ariaCurrentWhenActive="page">
          {{'app.titles.supportedDevices' | translate}}
        </a>
        <a class="drawer-btn" [routerLink]="'/devices/unsupported'" (click)="drawer.close()" routerLinkActive="active-m" [routerLinkActiveOptions]="{exact:true}" ariaCurrentWhenActive="page">
          {{'app.titles.unsupportedDevices' | translate}}
        </a>
      </div>
      <div class="drawer-actions">
        <a *ngIf="(isLoggedIn | async)" class="pushable green-push" [routerLink]="'/'" (click)="drawer.close()" routerLinkActive="active-m" [routerLinkActiveOptions]="{exact:true}" ariaCurrentWhenActive="page">
          <span class="front">
            <span>{{'app.titles.myAccount' | translate}}</span>
          </span>
        </a>
        <button *ngIf="(isLoggedIn | async)" class="icon-button login-btn" (click)="drawer.close();changePassword()">
          <span></span>
          <span class="visible-hidden">{{'resetPassword.change.form.changePassword' | translate}}</span>
        </button>
        <button *ngIf="(isLoggedIn | async)" class="icon-button logout-btn" (click)="logout()">
          <span></span>
          <span class="visible-hidden">{{'app.titles.logout' | translate}}</span>
        </button>
        <a *ngIf="!(isLoggedIn | async)" class="pushable green-push" [routerLink]="'/register'" (click)="drawer.close()" routerLinkActive="active-m" [routerLinkActiveOptions]="{exact:true}" ariaCurrentWhenActive="page">
          <span class="front">
            {{'app.titles.licenseActivation' | translate}}
          </span>
        </a>
        <a *ngIf="!(isLoggedIn | async)" class="icon-button login-btn" [routerLink]="'/login'" (click)="drawer.close()" routerLinkActive="active-m" [routerLinkActiveOptions]="{exact:true}" ariaCurrentWhenActive="page">
          <span></span>
          <span class="visible-hidden">{{'app.titles.login' | translate}}</span>
        </a>
      </div>
      <div class="lang-btn">
        <button class="language-btn" (click)="changeAppLanguage()" [attr.aria-label]="('app.languageBtnAria' | translate)">
          <span>{{'app.languageBtnText' | translate}}</span>
        </button>
      </div>
      <div class="drawer-footer">
        <p class="s-h5">{{'app.footer.support.title' | translate}}</p>
        <p class="extra-small">
          <a class="email" href="mailto:{{env.resources.websiteOrMail}}">info@veglegestorles.hu</a>
        </p>
        <p class="extra-small">
          <a href="tel:+3614680673">(06 1) 468-0673</a>
        </p>
        <p class="extra-small">
          {{'app.footer.support.availableHours' | translate}}
        </p>
      </div>
    </div>
  </mat-sidenav>
  <mat-sidenav-content>

    <app-appbar [appDrawer]="drawer" *ngIf="!router.url.includes('report')"></app-appbar>

    <main id="mainContent" class="{{translate.currentLang}}">
      <router-outlet></router-outlet>
    </main>

    <app-footer *ngIf="!router.url.includes('report')"></app-footer>

  </mat-sidenav-content>
</mat-sidenav-container>
